import React from "react";
import { Link } from "react-router-dom";

const FooterLegal = () => {
  return (
    <div>
      <h3 className="font-bold mb-4 text-lg">Legal</h3>
      <ul className="space-y-2">
        <li>
          <Link
            to="/legal/privacy-policy"
            className="text-gray-300 hover:text-white transition-colors"
          >
            Privacy Policy
          </Link>
        </li>
        <li>
          <Link
            to="/legal/terms-of-service"
            className="text-gray-300 hover:text-white transition-colors"
          >
            Terms of Service
          </Link>
        </li>
        <li>
          <Link
            to="/legal/gdpr-compliance"
            className="text-gray-300 hover:text-white transition-colors"
          >
            GDPR Compliance
          </Link>
        </li>
        <li>
          <Link
            to="/legal/code-of-conduct"
            className="text-gray-300 hover:text-white transition-colors"
          >
            Code of Conduct
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default FooterLegal;
